import Swiper, {Navigation} from 'swiper';
import Accordion from '../../components/accordion';

const LAPTOP_MQ = '(min-width: 1280px)';

const initStudentsAdvantagesSlider = (root) => {
    const sliderContent = root.querySelector('.j-career-slider');
    const nextEl = root.querySelector('.j-career-next');
    const prevEl = root.querySelector('.j-career-prev');

    if (!sliderContent) {
        return null;
    }

    const slider = new Swiper(sliderContent, {
        init             : false,
        modules          : [Navigation],
        loop             : false,
        speed            : 800,
        spaceBetween     : 0,
        slidesPerView    : 'auto',
        slidesOffsetAfter: 30,
        navigation       : {
            nextEl,
            prevEl
        }
    });

    slider.init();

    return slider;
};

const studentsAdvantages = Array.from(document.querySelectorAll('.j-students-advantages'));

studentsAdvantages.forEach((root) => {
    let slider = null;
    const media = window.matchMedia(LAPTOP_MQ);

    const sync = () => {
        if (media.matches) {
            if (slider) {
                slider.destroy(true, true);
                slider = null;
            }

            return;
        }

        if (!slider) {
            slider = initStudentsAdvantagesSlider(root);
        }
    };

    sync();
    media.addEventListener('change', sync);
});

const studentsReviews = Array.from(document.querySelectorAll('.j-students-reviews'));

studentsReviews.forEach((root) => {
    const sliderContent = root.querySelector('.j-students-reviews-slider');
    const nextEl = root.querySelector('.j-students-reviews-next');
    const prevEl = root.querySelector('.j-students-reviews-prev');

    if (!sliderContent) {
        return;
    }

    const slider = new Swiper(sliderContent, {
        init             : false,
        modules          : [Navigation],
        loop             : false,
        speed            : 800,
        spaceBetween     : 0,
        slidesPerView    : 'auto',
        slidesOffsetAfter: 30,
        navigation       : {
            nextEl,
            prevEl
        }
    });

    slider.init();
});

const studentsFaq = document.querySelector('.j-students-faq-accordion');

if (studentsFaq) {
    const studentsFaqAccordion = new Accordion();

    studentsFaqAccordion.init(studentsFaq);
}
